import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestConversationSchema = z.object({
  researchRequestConversationId: PrimaryKeySchema,
  researchRequestId: PrimaryKeySchema,
  conversationId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequestConversation = z.infer<
  typeof ResearchRequestConversationSchema
>;

export const ResearchRequestConversationFiltersSchema = z.object({
  researchRequestConversationIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  conversationIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type ResearchRequestConversationFilters = z.infer<
  typeof ResearchRequestConversationFiltersSchema
>;
